import { Fragment, useEffect, useRef, useState } from "react";
import { FaEnvelope } from "react-icons/fa6";
import { IoTicket } from "react-icons/io5";
import { Link } from "react-router-dom";
import useMessageTicket from "../../../../../hooks/useMessageTicket";
import useSharedData from "../../../../../hooks/useSharedData";
import "./messages.css";

function Messages() {
  const { user } = useSharedData();
  const { unreadMessages, countUnread, unreadTickets } = useMessageTicket();

  const messageBox = useRef(null);
  const [showMessageBox, setShowMessageBox] = useState(false);

  useEffect(() => {
    const handleClickOutside = e => {
      if (messageBox.current && !messageBox.current.contains(e.target)) {
        setShowMessageBox(() => false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [messageBox]);

  if (!user) return <Fragment></Fragment>;

  return (
    <div className="position-relative d-none d-sm-block" ref={messageBox}>
      <div
        className="menu-message"
        onClick={() => setShowMessageBox(curr => !curr)}
      >
        <div className="menu-bell">
          <FaEnvelope />
        </div>
        <div className="menu-bell-Box">
          <span className="menu-bell-number">{countUnread()}</span>
        </div>
      </div>

      {showMessageBox && (
        <div
          className="menu-message-box overflow-y-auto"
          style={{ maxHeight: "600px", width: 350 }}
        >
          {unreadMessages.map((item, index) => (
            <div className="d-flex flex-column" key={index}>
              <Link to="/messages">
                <article className="menu-message-sub p-2 text-dark">
                  <h6>
                    <span>
                      <FaEnvelope size="24" color="#ff8800" />
                    </span>
                    <span className="me-3">پیام</span>
                  </h6>

                  <div className="px-2">
                    <p className="mb-0">
                      <strong>{item.title.slice(0, 35)}</strong>
                    </p>
                    <hr className="my-1" />
                    <p className="mb-0">{item.body.slice(0, 35) + " ..."}</p>
                  </div>
                </article>
              </Link>
            </div>
          ))}

          {unreadTickets.map((item, index) => (
            <div className="d-flex flex-column" key={index}>
              <Link to="/account/tickets">
                <article className="menu-message-sub p-2 text-dark">
                  <h6>
                    <span>
                      <IoTicket size="24" color="#4b1483" />
                    </span>
                    <span className="me-3">تیکت</span>
                  </h6>

                  <div className="px-2">
                    <p className="mb-0">{item.answer.slice(0, 35) + " ..."}</p>
                  </div>
                </article>
              </Link>
            </div>
          ))}

          <Link
            to="/messages"
            className="d-block mt-4 btn-cancel-style w-75 text-center"
          >
            صفحه ی پیام ها
          </Link>

          <Link
            to="/account/tickets"
            className="d-block mt-2 btn-success-style w-75 text-center"
          >
            صفحه ی تیکت ها
          </Link>
        </div>
      )}
    </div>
  );
}

export default Messages;
